import { motion } from "framer-motion";
import { MaskedLines } from "@/components/Reveal";

export default function PageHeader({ overline, title, subtitle, lines }) {
  return (
    <section
      className="px-6 md:px-12 max-w-7xl mx-auto pt-16 md:pt-24 pb-10 md:pb-14"
      data-testid="page-header"
    >
      {overline && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7 }}
          className="text-xs uppercase tracking-[0.35em] text-[var(--oxblood)] mb-6"
        >
          {overline}
        </motion.p>
      )}

      <h1 className="font-serif font-light text-5xl md:text-7xl leading-[0.98] tracking-tight text-[var(--ink)] max-w-4xl">
        {lines ? <MaskedLines lines={lines} /> : title}
      </h1>

      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.7 }}
          className="mt-7 text-[var(--muted)] max-w-3xl text-lg leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </section>
  );
}